import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { LockKey, ArrowRight } from "@phosphor-icons/react";

function formatErr(detail) {
  if (!detail) return "Login failed";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return JSON.stringify(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@hangang.global");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 holo-bg" data-testid="admin-login-page">
      <Link to="/" className="absolute top-6 left-6 font-display font-black tracking-tighter text-lg" data-testid="login-back-home">
        HANGANG<span className="text-[#FF6B9E]">.</span>GLOBAL
      </Link>
      <div className="w-full max-w-md glass rounded-3xl p-8 md:p-10">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-[#0F172A] text-white flex items-center justify-center">
            <LockKey size={22} weight="bold" />
          </div>
          <div>
            <div className="label-uppercase text-[#FF6B9E]">Admin</div>
            <h1 className="font-display text-2xl font-black tracking-tight">Studio access</h1>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="label-uppercase block mb-2">Email</label>
            <input
              type="email"
              required
              data-testid="login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white/80 border-2 border-slate-200 rounded-2xl px-4 py-3 focus:border-[#FF6B9E] focus:outline-none font-medium"
            />
          </div>
          <div>
            <label className="label-uppercase block mb-2">Password</label>
            <input
              type="password"
              required
              data-testid="login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white/80 border-2 border-slate-200 rounded-2xl px-4 py-3 focus:border-[#FF6B9E] focus:outline-none font-medium"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="btn-pill-primary w-full justify-center disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"} <ArrowRight size={16} weight="bold" />
          </button>
        </form>
      </div>
    </div>
  );
}
